/* AEVORA — galerie fiche produit : miniatures cliquables.
   La section aevora-landing ne rend qu'une seule image et laisse
   .aevora-hero-thumbs vide ; les autres photos du produit sont donc
   invisibles. On les recupere via /products/{handle}.js et on construit
   le rail. Sans JS, la page reste telle quelle (une photo) : rien ne casse. */
(function () {
  var d = document;

  var CSS = [
    '.aevora-root .aevora-hero-thumbs{display:flex;gap:8px;margin-top:10px;overflow-x:auto;scrollbar-width:none;padding:2px}',
    '.aevora-root .aevora-hero-thumbs::-webkit-scrollbar{display:none}',
    '.aevora-root .aevora-hero-thumbs .aevora-thumb{flex:0 0 auto;width:64px;height:64px;border-radius:10px;overflow:hidden;border:2px solid transparent;padding:0;background:#f6ece7;cursor:pointer}',
    '.aevora-root .aevora-hero-thumbs .aevora-thumb.is-active{border-color:#9D5542}',
    '.aevora-root .aevora-hero-thumbs .aevora-thumb img{width:100%;height:100%;object-fit:cover;display:block}',
    '.aevora-root .aevora-hero-count{position:absolute;right:12px;bottom:12px;z-index:2;background:#3c1e14b8;color:#fff;font-size:12px;font-weight:700;padding:4px 10px;border-radius:999px}',
    '@media (min-width:901px){.aevora-root .aevora-hero-main .aevora-hero-img{height:clamp(320px,44vh,430px);object-fit:cover}}'
  ].join('');

  function injectCss() {
    if (d.getElementById('av-gal-css')) return;
    var s = d.createElement('style');
    s.id = 'av-gal-css';
    s.textContent = CSS;
    d.head.appendChild(s);
  }

  function sized(u, w) {
    if (!u) return u;
    return u.indexOf('?') > -1 ? u + '&width=' + w : u + '?width=' + w;
  }

  function init() {
    var gal = d.querySelector('.aevora-hero-gallery');
    if (!gal) return;
    var main = gal.querySelector('.aevora-hero-main');
    var img = gal.querySelector('.aevora-hero-img');
    if (!main || !img) return;

    var thumbs = gal.querySelector('.aevora-hero-thumbs');
    if (thumbs && thumbs.children.length) return;

    var seg = location.pathname.split('/products/')[1];
    if (!seg) return;
    var handle = seg.split('/')[0].split('?')[0].split('#')[0];

    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var urls = (p.images || []).slice(0, 12);
        if (urls.length < 2) return;

        injectCss();

        if (!thumbs) {
          thumbs = d.createElement('div');
          thumbs.className = 'aevora-hero-thumbs';
          gal.appendChild(thumbs);
        }

        var counter = d.createElement('span');
        counter.className = 'aevora-hero-count';
        counter.setAttribute('aria-hidden', 'true');
        if (getComputedStyle(main).position === 'static') main.style.position = 'relative';
        main.appendChild(counter);

        function show(i) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.setAttribute('src', sized(urls[i], 1200));
          counter.textContent = (i + 1) + '/' + urls.length;
          for (var k = 0; k < thumbs.children.length; k++) {
            thumbs.children[k].classList.toggle('is-active', k === i);
          }
        }

        urls.forEach(function (u, i) {
          var b = d.createElement('button');
          b.type = 'button';
          b.className = 'aevora-thumb';
          b.setAttribute('aria-label', 'Afficher la photo ' + (i + 1) + ' sur ' + urls.length);
          var t = d.createElement('img');
          t.src = sized(u, 160);
          t.alt = '';
          t.loading = 'lazy';
          t.width = 160;
          t.height = 160;
          b.appendChild(t);
          b.addEventListener('click', function () { show(i); });
          thumbs.appendChild(b);
        });

        show(0);
      })
      .catch(function () {});
  }

  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
